module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak",
      "title": "15"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("2")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("THE COLOR LINE")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_vm._v("Healing Racial Trauma")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last retrait_autre"
  }, [_c('i', [_vm._v("I am a man of substance, of flesh and bone, fiber and liquids—and I might even be said to possess a mind. I am invisible, understand, simply because people refuse to see me.")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALPH")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLISON")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("B")]), _vm._v("lack excellence comes in many different forms. My husband, Nick, and I knew early that our son, Jonathan, was a gifted empath with strong verbal, reading, and writing skills. However, his education was like a balancing act on a high wire with no safety net beneath, or if there was one, it had holes in it. Jonathan wrote this simple haiku, “Endurance,” that tells a powerful truth that our bodies are not our own according to Scripture:")]), _c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("I am present tense")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Even in a body")]), _c('p', {
    staticClass: "verslg"
  }, [_vm._v("Not my own."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-011",
      "id": "ap_ntf-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jonathan, now an adult, remembers when he was five years old, and the world cruelly told him that his Black body was not his own and his life didn’t matter. Because of the “color line,” the whole truth of God’s Word that he is fearfully and wonderfully made got "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak",
      "title": "16"
    }
  }, [_vm._v("distorted. The color line was coined by sociologist, historian, and civil rights activist Dr. W. E. B. Du Bois."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-012",
      "id": "ap_ntf-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" It refers to the invisible line that divides racial and ethnic groups. The influence of the color line has been and continues to be exerted systemically throughout America’s history from indigenous genocide, slavery, Jim Crow segregation laws, predatory lending, and mass incarceration. The color line ensures that White folks will be prioritized on one side of the line and receive the best goods, services, and access to opportunities while Black or Brown folks fight for the same, and many get whatever is left over or nothing at all. Secular and Christian circles alike fiercely debate whether the color line, racism, or systemic oppression still exists. Some White and even Black and Brown folks don’t see it because they’ve trained themselves—or have been trained—not to. The color line asserts its rigid boundaries, although the line is now written in invisible ink. Its effects are experienced transgenerationally and interpersonally. It inflicts racial trauma upon individuals, families, and communities.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Racism is embedded in many areas in this American life, communicating to many Black Americans that we don’t rate and are unwelcomed. It happens interpersonally, vicariously, institutionally, and in many ways devastates us, our families, and communities. Almost every day, we face subtle microaggressions, insults, racism, and bias and decide how or whether it’s worth a response. Whatever the choice, racism leaves the wounds and scars of racial trauma, defined as the physical and psychological symptoms that people of color often experience after a stressful racist incident.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These personal or vicarious incidents and systemic racism happen repeatedly and cause toxic stress to accumulate in our bodies and contribute to racial trauma. This more insidious, chronic stress negatively affects our emotions, minds, bodies, spirits, and relationships."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-013",
      "id": "ap_ntf-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" When we experience a threat, our "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak",
      "title": "17"
    }
  }, [_vm._v("brains are wired to prepare our bodies to fight or flight. This stress response causes our nervous systems, hormones, minds, and bodies to be on high alert, causing us to believe we need to take immediate action against an actual threat. However, if the risk or the traumatic stress is not dealt with, our brains and bodies don’t fully stand down, and we get stuck in an endless loop. Our traumatic stress triggers a physical and emotional response, which then feeds our traumatic stress."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-014",
      "id": "ap_ntf-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to the report titled "), _c('i', [_vm._v("The Impact of Racial Trauma on African Americans")]), _vm._v(", the effects of racial trauma include fear, aggression, depression, anxiety, low self-image, shame, hypervigilance, pessimism, nightmares, difficulty concentrating, substance abuse, flashbacks, and relational dysfunction. We also carry unhealed racial trauma in our bodies. The physical symptoms include hyperactivity, heart disease, headaches, and poor concentration."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-015",
      "id": "ap_ntf-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" When symptoms of psychological stress show up in our bodies, we may experience "), _c('i', [_vm._v("weathering")]), _vm._v(". The term describes how racism causes racial trauma that may lead to premature aging and poor health for Black people. We have disproportionately high death rates from chronic conditions such as heart disease, stroke, diabetes, and cancer."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-016",
      "id": "ap_ntf-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" More recently it has contributed to an inordinate number of Black folks contracting and dying from Covid-19.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Over twenty years ago, I picked Jonathan up from preschool, and as he tightly held onto my hand, he was sullen. I asked how his day was. Absent was the usual chatter about the book he read or recess fun playing tag with the tow-haired twin boys. When we got home, instead of darting across the street to play with his besties, Jonathan waved to them, then rushed inside. Later, his eyes welled up with tears as he told my husband and me, “I don’t want to go back to that school anymore; they make me feel like I’m stupid and can’t do anything.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-017",
      "id": "ap_ntf-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak",
      "title": "18"
    }
  }, [_vm._v("The next day when I picked him up from his preschool, I pulled his teacher, Ms. Evans, aside and repeated Jonathan’s words. Through pursed lips, she insisted that Jonathan had no friends. I countered that he had good friends, our neighbors, the Greco boys, and he played well with classmates the O’Malley twins. She responded, “The twins are just like him.” Ms. Evans said that Jonathan should be tested for attention deficit hyperactivity disorder (ADHD) and prescribed medication to calm him down. I told her there was no need for medication because he could focus, and if given the option, he’d rather sit quietly and read a book for hours."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-018",
      "id": "ap_ntf-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A diagnosis of ADHD is all too common for Black kids. A systematic review of twenty-one previously published studies shows that when ADHD symptoms are reported by teachers, “they usually reported more symptoms for Black youth.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-019",
      "id": "ap_ntf-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Ms. Evans was a case in point; she refused to budge from her prognosis. She then pointed to the floor in the front of the classroom, where a large "), _c('i', [_vm._v("X")]), _vm._v(" was made of silver duct tape. Ms. Evans said that she made Jonathan sit cross-legged on the floor each day, and he wasn’t allowed to move from that spot. Those clearly visible lines were an invisible leash meant to keep him tethered. The color line is like that invisible leash. Black folks, regardless of socioeconomic status, often stare down the color line and have to decide if or when to deny, endure, cross over, or expose it.")]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-003"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("BLACK FOLKS, REGARDLESS OF SOCIOECONOMIC STATUS, OFTEN STARE DOWN THE COLOR LINE AND HAVE TO DECIDE IF OR WHEN TO DENY, ENDURE, CROSS OVER, OR EXPOSE IT.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A BLACK MOTHER’S JOURNEY")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Exodus 1:22–2:8, Pharaoh ordered every Hebrew boy born alive to be thrown into the river Nile. Jochebed placed her three-month-old son in a papyrus basket that she coated with pitch and tar. She placed the basket among the billowing reeds along the riverbank and prayed it was waterproof.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jochebed’s daughter, Miriam, watched from a distance to see if the baby would float away to safety. As Pharaoh’s daughter was walking along the riverbank, she soon discovered the crying Hebrew baby and felt compassion toward him. Miriam asked if she could get a Hebrew woman to nurse the baby. She then went and returned with Jochebed, and Pharaoh’s daughter unknowingly agreed to pay the mother to nurse her own baby. When the baby was older, Jochebed took him to Pharaoh’s daughter. He became her son, and she named him Moses, saying, “I drew him out of the water.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This story is not unlike the experience Black mothers have endured throughout generations. We pray for our children to thrive, and we hope for a better life. So, we place them on yellow school buses or in advanced classes that transport them to another world—the world of privilege where our children are schooled in the ways of Pharaoh. Like Jochebed, we watch and wait as our children are named and nurtured by those who will also one day proclaim they rescued our child from drowning.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Nick and I wanted the best education for our gifted son. We believed the principal when she said the parochial school had many great things to offer Jonathan, both socially and academically. But there I was, fighting to hold back tears as I fixed on the "), _c('i', [_vm._v("X")]), _vm._v(" that marked the spot. I became angry and felt betrayed.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jonathan was the lone Black boy in his class. As an adult, he describes himself at five as “a joyous flame large enough to light "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak",
      "title": "20"
    }
  }, [_vm._v("up a room.” I certainly agree with his assessment. Yet, there he was, full of life and light, a fire his teacher could not control but tried to diminish. Jonathan’s experience is validated by reports such as found in "), _c('i', [_vm._v("The Journal of Emotional Abuse")]), _vm._v(", which confirms racism’s impact on the education of African American males. Racism “contributed to low teacher expectations, heavy reliance on biased standardized tests, the overrepresentation of African American males in special education, and the disproportionally large numbers of kids of color who are diagnosed with attention deficit hyperactivity disorder (ADHD) and placed on Ritalin.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Meanwhile, for the twins, also full of energy, no "), _c('i', [_vm._v("X")]), _vm._v(" was taped to the floor. They received a hall pass. Ms. Evans’s actions inflicted racial trauma and sent a clear message to Jonathan that he did not belong and who he was and what he needed were irrelevant.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("On the subject of intergenerational trauma,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Researcher Allan Young argues that trauma is a disease of time, where the “past invad[es] the present in re-experiences and re-enactments” and a person attempts to “defend himself from the consequences”; we are shaped not only by our memories, but by our “present interpretations of events that can continue to impact our lives.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-021",
      "id": "ap_ntf-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Many of us are unaware of how historical racial trauma rather than individual trauma spans multiple generations and still affects us."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-022",
      "id": "ap_ntf-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" We may carry trauma-related symptoms without having been present for the past traumatizing event."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-023",
      "id": "ap_ntf-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Some studies have shown that historical and transgenerational racial trauma can be transmitted across a specific family line. "), _c('i', [_vm._v("Epigenetics")]), _vm._v(" is the study of the transmission of information from one generation to the next, which affects the genes of offspring without "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak",
      "title": "21"
    }
  }, [_vm._v("altering the primary structure of DNA. Some studies are inconclusive, but other research has shown that our minds may forget, but our bodies don’t. Deep inside every cell, a memory trace is stored of every event we have ever experienced and the sensations and feelings that occurred with them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-024",
      "id": "ap_ntf-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Another research study reported how historical and transgenerational racial trauma can be transmitted through family dynamics, storytelling, or folklore that tie us to our ancestors."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-025",
      "id": "ap_ntf-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As Jonathan experienced difficulties at school, it was retraumatizing for both of us. It was painful for me to see him treated as “other”—a pest and unwelcomed. But the way he was treated by his teacher reminded me of my own educational experience being bused to all-White schools in Boston. When I was his age, and throughout my life, it was hard to ask for what I needed. I couldn’t tell my parents about the abuse I suffered at the hands of racist teachers who shamed me and continuously questioned my intellect. I stayed quiet and followed most of the rules of engagement.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet now I had a significant role in Jonathan’s healing journey, which unexpectedly contributed to my own healing process. As his parent, it was both painful and a joy to witness him speaking up and asking for help. For a five-year-old, Jonathan was very articulate about how he felt, and he felt safe enough in our relationship to express his needs. He knew he would be heard.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Some of us navigate the rough terrain of education in majority-White institutions the way Moses did in Pharaoh’s palace. We often have a "), _c('i', [_vm._v("dual-consciousness")]), _vm._v(" as referenced by Dr. Du Bois: “It is a peculiar sensation, this double-consciousness, this sense of always looking at oneself through the eyes of others, of measuring one’s soul by the tape of a world that looks on in amused contempt and pity.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-026",
      "id": "ap_ntf-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Although Moses was steeped in Egyptian "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "role": "doc-pagebreak",
      "title": "22"
    }
  }, [_vm._v("language and culture and was considered a son in the royal household, he knew his Hebrew lineage. Yet, he could only stand by and watch the devastation and racial trauma Pharaoh inflicted on the Israelites. Moses may have been racially traumatized as he witnessed his kin’s marginalization, the beatings and brutality of slavery, the lack of adequate housing and food. As Moses rose to prominence in Pharaoh’s palace, I wonder if guilt and shame weighed heavily on him.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Everything changed in a moment when Moses saw an Egyptian beating a Hebrew and couldn’t take it any longer. In a rage, he lashed out and killed the Egyptian and hid the body in the sand. A fellow Israelite witnessed this, and Moses feared exposure and a likely death sentence for the murder, so he fled to Midian ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Exodus%C2%A02%3A11-15&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Exodus 2:11-15")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("MISEDUCATION")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Moses lashed out in rage to protect his people. I felt angry and protective of Jonathan but was determined and prayerful about harnessing it to fight for positive change. The next day, I met with Jonathan’s preschool principal, Mrs. Greyson, and Ms. Evans. I voiced my complaint about Ms. Evans’s attempts to constrain Jonathan both physically and emotionally. Ms. Evans denied her words and actions were meant to harm or demean me or shame our son. The refusal of both women to address the damage caused left us no choice but to pull Jonathan out of school. That day, we began our flight out of Egypt.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Despite the financial burden of reducing my counseling caseload, I homeschooled Jonathan for the rest of the year. We decided to go forward with testing for ADHD, and the reports came back with an inconclusive diagnosis. It did reveal a spatial processing issue, which meant Jonathan would need remedial "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "role": "doc-pagebreak",
      "title": "23"
    }
  }, [_vm._v("help with mathematics. Yet there was not a recognition of his areas of strength and giftedness. A 2015 report states how common it is that “gifted characteristics overlap the symptoms of ADHD for many gifted children. The potential for the misdiagnosis of giftedness as ADHD exists.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-027",
      "id": "ap_ntf-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" We believed this was the case with Jonathan, and we were determined to forego experimenting with medication, concerned about how it might dampen down Jonathan’s creativity and love for learning.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After months of homeschooling, I returned to work and Jonathan to a new school. I wish I could say it was a smooth ride, but it was not. I’m reminded of another story of Jesus and the little children from Matthew 18:5, where Jesus tells us, “Whoever welcomes one such child in my name welcomes me.” Too often, Jonathan was shut out of a particular Christian private school or public school; each time this happened, so was Jesus. There were many times I wept and railed as another school tried to pigeonhole Jonathan. In the educational system, there were no real safety nets for kids like him. If there were, the safety nets had holes in them, so we had to make our own.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We read to Jonathan and his sister, Alexia, every night. Jonathan memorized "), _c('i', [_vm._v("Ezra’s Snowy Day")]), _vm._v(", "), _c('i', [_vm._v("Jonathan and His Mommy")]), _vm._v(", and all the books in the Beatrix Potter series. The "), _c('i', [_vm._v("Encyclopedia Britannica")]), _vm._v(" was downloaded onto our computer. Jonathan spent countless hours on it reading, looking at pictures, and listening to music. He watched travel and cooking shows that took him to exotic places. Jonathan had an insatiable curiosity. He and Alexia’s favorite pastime was browsing through the stacks at our local library or bookstore. We’d often find them sprawled out on the library floor, sitting cross-legged with a book on their laps, engrossed in life on another planet or in a foreign country. The librarian and shop owners often commented with delight at how "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "role": "doc-pagebreak",
      "title": "24"
    }
  }, [_vm._v("both kids were voracious readers who were welcome to return any time. We held creative writing contests between Jonathan and Alexia. We saw the bright spark grow into a flame in Jonathan as we nurtured his passion for reading and writing.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There will always be Pharaohs with hardened hearts toward the cries of a Moses. They will refuse to let the people go free. Our gifted ones are not insulated from the barriers erected by Pharaohs. Systemic racism builds fortified cities on the backs of the poor and oppressed and demands we magically make bricks for our own homes without straw. Pharaohs attempt to dictate the terms for freedom, limiting the type of youth who may successfully go forward. Some of our youth must pass a biased entrance exam to be admitted into certain schools. But sometimes hope and change come in unexpected ways.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A WHOLE VILLAGE")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The world continued to try to force Jonathan into a narrative created about who Black boys are and what they’re capable of accomplishing. I am reminded of a few lines from a Langston Hughes poem: “I am the darker brother. They send me to eat in the kitchen when company comes, But I laugh, and eat well, and grow strong.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-028",
      "id": "ap_ntf-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Well, Jonathan grew strong and proved everyone wrong, and so did we. We didn’t tell Jonathan about the inconclusive diagnosis. He was aware that he struggled with math, but we refused to have him misdiagnosed and labeled. We had to remain vigilant to get his needs met. I joined the parent and teacher council and gave input into an individual education plan (IEP) drafted for Jonathan. He is considered twice-exceptional, or 2e, which typically refers to more than one disability present alongside high learning potential. “While twice-exceptional, African American students may face many "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "role": "doc-pagebreak",
      "title": "25"
    }
  }, [_vm._v("educational and social challenges, they can still be successful in their schooling.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-029",
      "id": "ap_ntf-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Amanda Gorman, the National Youth Poet Laureate who powerfully spoke at the inauguration of President Joe Biden, experienced this. Amanda has an auditory and verbal processing disorder. From her mother, Joan Wicks: “‘Every child has a gift. It just has to be discovered,’ she says. ‘Where there’s a deficit, there’s a place where the child makes it up.’ Amanda says, ‘My challenges were always, just for me, something that was reality, but I knew I had strengths, too, especially with words and writing.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-030",
      "id": "ap_ntf-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Some of our stories mirror Amanda Gorman’s.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This was Jonathan’s journey as he trucked down old, dusty stairs to a basement room where the special education class was held. He said, “My new teacher was warm, welcoming, and I understood that I would get help with math, and ironically, I got help with reading, which was strange given how passionate I was about reading.” We were overjoyed that he’d encountered a competent and caring educator. But every night, as Jonathan slept, Nick and I prayed over him for the Lord to heal the racial trauma he’d experienced. We also prayed for the purpose and plan that the Lord had for his life to prevail.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another study reinforced earlier findings that engaged parents and caregivers are key to a child’s successful education and further confirms that parents trust in their power and that of other parents."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-031",
      "id": "ap_ntf-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Also, the longstanding influence of African American clergy continues to resonate with parents and caregivers as reinforced by these data.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The research is a reminder that it may be cliché, but it does take a whole village to raise a child. We were members of a Black church where both of our children grew in their Christian faith and were celebrated and encouraged to rise up and use their gifts in the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "role": "doc-pagebreak",
      "title": "26"
    }
  }, [_vm._v("community. Nick and I were active in Jonathan’s school and attended every meeting. Studies have found that if gifted ones are to develop into self-fulfilled adults, they need to understand how they are different from others and how they are the same. They need to accept their abilities, talents, and limitations. They need to develop social skills and feel understood and accepted. And they need to understand the difference between “pursuit of excellence” and “pursuit of perfection.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-032",
      "id": "ap_ntf-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Nick and I were intentional about looking for new ways to meet Jonathan’s needs and help him mature through every stage of his life.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("THIRD CULTURE")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When Jonathan was eleven years old, we took a leap of faith and moved to Johannesburg, South Africa. The fight for his education continued. We often had to move schools and were denied admission because of the lack of services or overt racism and bias. Then every once in a while, there was a teacher, pastor, ally, and friend who proclaimed that Jonathan’s body was the Lord’s and that his Black life mattered. Two countries and eight schools later, a White Afrikaner educator in South Africa disregarded the tests and the biases and told us what we always knew: Jonathan was academically gifted and did not belong in a remedial class or school; he only needed math help. There was a substitute high school English teacher who presented a poetry lesson where the students were to write a poem about a day in a season of the year. She read aloud Jonathan’s poem about a rainy day and was drawn to the imagery of the rain. She exclaimed loudly, “You are a poet!” Sometimes, one word or comment can change the trajectory of a person’s life. Jonathan later graduated high school with merit and moved back to America to attend college.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "role": "doc-pagebreak",
      "title": "27"
    }
  }, [_vm._v("Jonathan said, “Starting college was intimidating. I spent the first semester with my head down, studying, and isolated in my dorm room.” The one thing he thoroughly enjoyed were the classes he took in his major: writing, editing, and publishing. It took months for him to emerge from his shell. Kenneth V. Hardy describes similar experiences with students like Jonathan: “Although suffering from internalized devaluation and an assaulted sense of self, there is an untapped hero within that has been overshadowed by stereotyping, pathologizing, demonizing, and criminalizing.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-033",
      "id": "ap_ntf-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("During the years that followed, the untapped hero in Jonathan emerged. He discovered dormant leadership skills. He led an InterVarsity Bible study on his campus. He was also active in the Black Student Union (BSU), and for a time, he led the group. The BSU was a sanctuary, a place that offered respite from the ravages of racism. It was also a community of activists committed to transforming the college and society.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("During Jonathan’s sophomore year, he and other members marched with other area colleges to protest the Black lives impacted and lost by police violence and systemic oppression. In November, Jonathan, the BSU members, and allies carrying large signs marched across the quad and into the college president’s office. They brought a list of demands about improving diversity, inclusion in curriculum, and services on the campus. They shared their pain as Black students at the predominately White institution. The president listened and agreed to all of their demands. It was a pivotal moment assuring needed resources were released to BSU and other inequities were addressed.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Four years later, Jonathan earned a Kingston-Mann Student Achievement Award for his essay “Cross-cultural Navigations in Julia Alvarez’s "), _c('i', [_vm._v("How the Garcia Girls Lost Their Accents ")]), _vm._v("and Chimamanda Adichie’s "), _c('i', [_vm._v("Americanah.")]), _vm._v("” Johnathan reevaluated")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "role": "doc-pagebreak",
      "title": "28"
    }
  }, [_vm._v("traditional notions of identity formation for internationally mobile children, namely refugees, immigrants, asylum-seekers, child-migrants and even wealthy expatriates . . . and explore[d] how internationally mobile children adjust to life in adopted countries and form transcultural identities, paying special attention to how this affects their relationship with their country of origin."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-034",
      "id": "ap_ntf-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jonathan connected with the narratives in the books because it is his story as a "), _c('i', [_vm._v("third-culture kid")]), _vm._v(" (TCK). Third-culture kids “spend their formative years in places that are not their parents’ homeland. Globalisation has made TCKs more common.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-035",
      "id": "ap_ntf-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Jonathan said, “I completely relate, in several ways, to the characters in the novels that I’m analyzing, particularly in the idea of balancing different cultural identities and ensuring that the culture I grew up with is not lost in the process.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-036",
      "id": "ap_ntf-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" A month later, Jonathan graduated college, magna cum laude with distinction in his field of study—an honor bestowed on students who complete and present a significant research project. We had so much to celebrate.")]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-004"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("JUST AS WE NEED TO HAVE SAFER SPACES TO DEEPLY SHARE, LAMENT, AND GRIEVE THE LOSS AND DAMAGE DONE, WE ALSO NEED SPACES FOR CELEBRATION.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-011"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CELEBRATIONS")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Just as we need to have safer spaces to deeply share, lament, and grieve the loss and damage done, we also need spaces for celebration. We need to create events, traditions, and rituals that celebrate Black lives and victories even during difficult times. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "role": "doc-pagebreak",
      "title": "29"
    }
  }, [_vm._v("Celebrations give voice and shape to gratitude, a posture that aids in our healing. We wanted to celebrate Jonathan’s accomplishment, but more importantly, we wanted to celebrate who he is. On the day of Jonathan’s college graduation, we booked a table at a seafood restaurant on the North Shore to celebrate the milestone. The entrance to the seafood restaurant was flanked by a series of large windows. Inside, White guests sat at the bar, laughing and sipping glasses of wine. Some glanced as we passed, their eyes following us as we entered through the wooden door. At the hostess station, a passing thought occurred to me—"), _c('i', [_vm._v("were we welcome here?")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-037",
      "id": "ap_ntf-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The hostess sat us at a round table at a large window, and I felt as though we were on display. As we sat, a memory surfaced of when Jonathan’s preschool teacher put him on display. Years have passed, and I am grateful the invisible leash is gone; Jonathan is unbound."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-038",
      "id": "ap_ntf-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" So, we celebrated rather than fixating on the trauma and dramas of this world that would swallow us whole. We did not talk in hushed tones or code-switch to be more acceptable. We refused to have our Black joy policed. If need be, we would assert our right to rejoice in our victories anywhere and anyhow.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Old Testament promises in Jeremiah 29:11-14 are also valid for us today:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("“For I know the plans I have for you,” declares the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", “plans to prosper you and not to harm you, plans to give you hope and a future. Then you will call on me and come and pray to me, and I will listen to you. You will seek me and find me when you seek me with all your heart. I will be found by you,” declares the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", “and will bring you back from captivity.”")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("So, we look for and celebrate Christ’s radical joy and hope that arises within and around us. Jonathan has come far after years of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "role": "doc-pagebreak",
      "title": "30"
    }
  }, [_vm._v("captivity. As we looked for other people and institutions to be a safety net, we remembered all the times we had to darn our own. I now see that although Pharaoh tries to dictate the movements of gifted ones like Jonathan, we persevered because always there underneath us are the everlasting arms.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Jonathan is now an accomplished award-winning poet and writer. He and his wife, Elisa, have hearts to change the false narrative about Black and Brown kids. Jonathan works for an international nonprofit organization and is a long-term volunteer at an urban writing and tutoring project. He’s been accepted into a master’s program in library and information science. He is committed to helping children and teens to uncover their gifts and offering ongoing support to help them move toward their dreams. This is a form of activism that has been healing for him. When we take agency, pursue personal healing, and use our gifts for the cause of justice for the poor and oppressed, we stand against the pessimism that says nothing will ever change.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When asked for one piece of advice he would give to his younger self to keep moving forward, Jonathan said,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Be courageous in all that you do. Know that this country was not built to hold the fullness of your body and that is okay. Stand firm in who God made you to be, and don’t be afraid to raise your voice against the injustice that you see around you. Also take heart that though things take time and life comes with much struggle and sacrifice, you’ll eventually get to where you want to be.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I’ve since completed a "), _c('i', [_vm._v("genogram")]), _vm._v(", a visual map of my family tree, and it showed that I’ve come from a long line of folks who faced racism and bias due to the color line and yet, against all odds, continued to strive for a better life. By God’s grace, we can take "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "role": "doc-pagebreak",
      "title": "31"
    }
  }, [_vm._v("Jonathan’s advice and also expose the color line written in invisible ink. We can write our own narratives. We can find and create places of respite from the vestiges of the color line. We are the best of Black excellence. We celebrate the milestones, joys, victories, and embrace our gifts and whole life—not caricatures. We celebrate all that we are, what we bring, and what we are becoming.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("REFLECTION")]), _c('ul', {
    staticClass: "liste_autre"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Read the instructions and complete the genogram in appendix one. How have you and your family been affected by the color line?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What help do you need right now, and what may help you heal from the color line’s damaging effects?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("Are there trustworthy folks who will listen to your experiences, celebrate your victories, and receive prayer? How might you be that for someone else?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_justif"
  }, [_vm._v("What do you feel called to do to help eradicate the color line?")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("EMBODIED PRAYER PRACTICE")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This prayer will use water to symbolize the cleansing of our wounds. In John 19:34–35, we read how “one of the soldiers pierced Jesus’ side with a spear, bringing a sudden flow of blood and water.” The blood and water that flowed out signified justification and sanctification: blood for atonement, water for purification.")]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Dear Lord,")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Your Word ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Psalm+139%3A13-14&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Psalm 139:13-14")]), _vm._v(") says, “You created my inmost being. You knit me together in my mother’s womb. I praise you because I am fearfully and wonderfully made. Your works are wonderful, I know that full well.” Yet, I have struggled to accept this as true. I, my family, and the Black community have been hurt by the color line. Some people have rejected us because of the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "role": "doc-pagebreak",
      "title": "32"
    }
  }, [_vm._v("color of our skin, race, and ethnicity. We carry the pain of these experiences. There are ways that we may believe the messages of the color line that although young, gifted, and Black, we are somehow less than. Lord, I confess, and renounce the lie. "), _c('i', [_vm._v("[What have you believed about yourself that is not true?]")]), _vm._v(" When I have rejected others based on skin tone, racism, and ethnic bias, Lord, I also confess and renounce those lies. "), _c('i', [_vm._v("[What have you believed about skin tone, other races, and other ethnicities that is not true?]")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Lord, please forgive me. As I take this water and apply it to my heart and forehead, may it symbolize and remind me that you cleanse my wounds and heal my pain. I can now begin to walk in a new, living, and loving way. "), _c('i', [_vm._v("[Listen in prayer, read the Word, and record what you believe the Lord is saying to you about this.]")]), _vm._v(" Lord, help me to love like you do; to love, honor, and celebrate others as children also created in your image. "), _c('i', [_vm._v("[Listen in prayer, read the Word, and record what you believe the Lord is saying to you about this.]")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the name of Jesus. Amen.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 69
// module chunks = 0